import { render, staticRenderFns } from "./communityMiniList.vue?vue&type=template&id=36a52954&scoped=true"
import script from "./communityMiniList.vue?vue&type=script&lang=js"
export * from "./communityMiniList.vue?vue&type=script&lang=js"
import style0 from "./communityMiniList.vue?vue&type=style&index=0&id=36a52954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a52954",
  null
  
)

export default component.exports